import { PROFILE } from "../data";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="relative px-4 md:px-6 pb-6">
      <div className="max-w-[1240px] mx-auto card px-7 md:px-10 py-7 flex flex-col md:flex-row items-center justify-between gap-4">
        <div className="flex items-center gap-2 font-display font-semibold">
          <span className="w-6 h-6 rounded-md bg-accent inline-flex items-center justify-center text-white text-xs font-bold">J</span>
          Jesal Sharma
        </div>
        <p className="text-ink-soft text-sm">© {new Date().getFullYear()} — Product Manager, B2B SaaS & Enterprise</p>
        <div className="flex items-center gap-5 font-display text-sm">
          <a href={PROFILE.linkedin} target="_blank" rel="noreferrer" className="link-underline">LinkedIn</a>
          <a href={`mailto:${PROFILE.email}`} className="link-underline">Email</a>
        </div>
      </div>
    </footer>
  );
}
